var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Contact"},[_c('div',{staticClass:"name"},[_vm._v(" 联系我们 ")]),_c('div',{staticClass:"collapse"},[_c('h3',[_vm._v("可信大数据武汉有限公司")]),_c('p',[_vm._v("武汉地址：武汉市洪山区珞珈山路19号中科开物大厦12楼")]),_c('p',[_vm._v("联系电话： 027-87638980 陶老师")]),_c('p',[_vm._v("邮  箱：taowei@cnpkp.com")]),_c('p',[_vm._v("邮  编：430072")])])])
}]

export { render, staticRenderFns }